import { graphql } from "src/graphql/generated";

export const apiKeysQuery = graphql(/* GraphQL */ `
    query APIKeys($clientId: String!) {
        client(clientId: $clientId) {
            api {
                apiKeys {
                    ...apiKeyFields
                }
            }
        }
    }
`);
